/**
 * Avatar component.
 * @module components/theme/Avatar/Avatar
 */
import React from 'react';
import PropTypes from 'prop-types';
import { getInitials } from '@plone/volto/helpers/Utils/Utils';
import Image from '@plone/volto/components/theme/Image/Image';
/* custom code start */
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import { showUserDetails } from '../../../../../actions';
/* custom code end */

/* custom code start: size and color of the template (#19379) */
const defaultSize = 40;
const defaultColor = 'coral';
/* custom code end */
const defaultClassName = 'avatar circular';

/* custom code start: the initials are rendered as svg data url so that they
   can replace a portrait image that does not exist (#19379, #19371) */
const buildFallbackIcon = (radius, color, size, text, title = '') =>
  `data:image/svg+xml;utf8,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">` +
      `<circle cx="${radius}" cy="${radius}" r="${radius}" fill="${color}" />` +
      `<text x="50%" y="50%" text-anchor="middle" fill="white" font-size="${radius}px" font-family="Arial" dy=".3em">` +
      `${text || getInitials(title, 1)}</text></svg>`,
  )}`;
/* custom code end */

const Avatar = ({
  src,
  title,
  text,
  size,
  color,
  className,
  userId, // custom code
  preventDefault, // custom code
}) => {
  const radius = Math.round(size / 2);
  /* custom code start: always show an image, fall back to the initials when
     the portrait is missing, a click opens the user details modal (#19371) */
  const dispatch = useDispatch();
  const fallback = buildFallbackIcon(radius, color, size, text, title);
  return (
    <div className={cx(className, { link: !!userId })} title={title}>
      <Image
        src={src || fallback}
        alt={title}
        onClick={(e) => {
          if (preventDefault) {
            e.preventDefault();
          }
          if (userId) {
            dispatch(showUserDetails(userId));
          }
        }}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = fallback;
        }}
      />
    </div>
  );
  /* custom code end */
};

Avatar.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  /* custom code start */
  userId: PropTypes.string,
  preventDefault: PropTypes.bool,
  /* custom code end */
};

Avatar.defaultProps = {
  src: null,
  title: '', // custom code: getInitials needs a string (#19370)
  text: null,
  size: defaultSize,
  color: defaultColor,
  className: defaultClassName,
  /* custom code start */
  userId: null,
  preventDefault: false,
  /* custom code end */
};

export default Avatar;
